module.exports = __webpack_public_path__ + "img/next-white.1c5a1c22.svg";